import { LocationDropDownModel } from "src/app/shared/models/locations-drop-down-list.model";
import { LookupModel } from "./LookupModel";

export class SignedUserLocations {
    locations: LocationDropDownModel[] = [];
    flatLocations: LookupModel[] = [];
}